export default __webpack_public_path__ + "bb9e894ca841397aa54df5267bf38e6d.js";